var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-editor-container"},[_c('MonacoEditor',{ref:"editor",attrs:{"width":_vm.editorW,"height":_vm.editorH,"theme":_vm.theme,"language":"javascript","options":_vm.options,"value":_vm.code},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }